
<template>
  <div>
    <v-row no-gutters justify="center" align="center">
      <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text" :disabled="!canGoPreviousPage" @click="page -= 1">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <div class="ml-2 primary--text font-weight-bold">
        {{ pageFrom }} - {{ pageTo }}
      </div>
      <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text ml-2" :disabled="!canGoNextPage" @click="page += 1">
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: `InterventionsPager`,
  computed: {
    ...mapState(`ui/interventions`, {
      interventions: `list`,
    }),
    ...mapGetters(`ui/interventions`, {
      nbItemsPerPage: `currentNbItemsPerPage`,
    }),
    page: {
      get() { return this.$store.state[`ui/interventions`].page; },
      set(page) { this.$store.commit(`ui/interventions/SET_PAGE`, page); },
    },
    pageFrom() { return (this.page - 1) * this.nbItemsPerPage + 1; },
    pageTo() { return (this.page - 1) * this.nbItemsPerPage + this.interventions.length; },
    canGoPreviousPage() { return this.page > 1; },
    canGoNextPage() { return this.interventions.length === this.nbItemsPerPage; },
  },
  watch: {
    page() { this.$emit(`change`); },
  },
};
</script>

<style lang="scss">
</style>
